import React from 'react'
import SiteLink from './SiteLink'

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()

  const navigation = [
    { name: 'Home', href: '/' },
  ]

  const legal = [
    { name: 'Privacy', href: '/privacy-policy' },
    { name: 'Cookies', href: '/cookie-policy' },
    { name: 'Terms', href: '/terms-of-service' },
  ]

  return (
    <footer
      className="font-outfit relative z-30 bg-ink-green-canvas dark:bg-ink-green-canvas border-t border-ink-green-edge dark:border-ink-green-edge"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-8 sm:py-10 md:py-12">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
            {/* Company Info */}
            <div className="md:max-w-xs">
              <h3 className="text-lg font-medium tracking-[-.03em] mb-2 text-ink-green-ink dark:text-ink-green-ink">
                novahass<span className="text-ink-green-accent">.</span>partners
              </h3>
              <p className="text-ink-green-ink-soft dark:text-ink-green-ink-soft text-sm leading-[1.55]">
                Smarter Property Investment,<br />on Autopilot.
              </p>
              <a
                href="mailto:buildwealth@novahass.partners"
                className="mt-3 inline-flex min-h-[44px] items-center text-sm text-ink-green-ink-soft dark:text-ink-green-ink-soft underline decoration-1 underline-offset-[.24em] hover:text-ink-green-ink dark:hover:text-ink-green-ink transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink-green-accent focus-visible:ring-offset-2 focus-visible:ring-offset-ink-green-canvas"
              >
                buildwealth@novahass.partners
              </a>
            </div>

            {/* Navigation Links */}
            <div className="flex flex-row gap-8 sm:gap-12">
              {/* Pages */}
              <div>
                <h4 className="text-sm font-medium text-ink-green-ink dark:text-ink-green-ink mb-3">Menu</h4>
                <ul className="space-y-2">
                  {navigation.map((link) => (
                    <li key={link.name}>
                      <SiteLink
                        href={link.href}
                        className="inline-flex min-h-[44px] items-center text-ink-green-ink-soft dark:text-ink-green-ink-soft hover:text-ink-green-ink dark:hover:text-ink-green-ink transition-colors text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink-green-accent focus-visible:ring-offset-2 focus-visible:ring-offset-ink-green-canvas"
                      >
                        {link.name}
                      </SiteLink>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Legal */}
              <div>
                <h4 className="text-sm font-medium text-ink-green-ink dark:text-ink-green-ink mb-3">Legal</h4>
                <ul className="space-y-2">
                  {legal.map((link) => (
                    <li key={link.name}>
                      <SiteLink
                        href={link.href}
                        className="inline-flex min-h-[44px] items-center text-ink-green-ink-soft dark:text-ink-green-ink-soft hover:text-ink-green-ink dark:hover:text-ink-green-ink transition-colors text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink-green-accent focus-visible:ring-offset-2 focus-visible:ring-offset-ink-green-canvas"
                      >
                        {link.name}
                      </SiteLink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-ink-green-edge dark:border-ink-green-edge py-6 sm:py-8">
          <div className="text-center">
            <p className="text-xs sm:text-sm text-ink-green-ink-soft dark:text-ink-green-ink-soft">
              © {currentYear} novahass.partners. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
